<template>
    <div style="width:100%;heigh:100%;" id='InventoryTask'>
        <el-card class="table_searchbar">
            <el-row >
                <el-col :span="5">
                    <div class="" @keydown.enter="btnSearch()">
                    <span class="title">盘点单号：</span>
                        <el-select size="small" remote filterable clear  :remote-method="loadCodeList" style="max-width:180px;" v-model="searchForm.inventoryId" placeholder="盘点单号" filterable >
                            <el-option v-for="item in inventoryCodeList" :key="item.id" :label="item.code" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-col>
                
                <el-col :span="5">
                    <div class="" @keydown.enter="btnSearch()">
                        <span class="title">盘点名称：</span>
                        <el-input style="max-width:180px" size="small" v-model="searchForm.inventoryName" maxlength="16" placeholder="盘点名称"></el-input>  
                    </div>
                </el-col>

                <el-col :span="5">
                    <div class="" @keydown.enter="btnSearch()">
                    <span class="title">盘点方式：</span>
                        <el-select size="small" style="max-width:180px;" v-model="searchForm.inventoryWay" placeholder="盘点方式" filterable >
                            <el-option  key="0" label="按库位" :value="0"></el-option>
                            <el-option  key="1" label="按物料" :value="1"></el-option>
                        </el-select>
                    </div>
                </el-col>

                <el-col :span="5">
                    <div class="" @keydown.enter="btnSearch()">
                    <span class="title">仓库：</span>
                        <el-select size="small" style="max-width:180px;" v-model="searchForm.warehouseId" placeholder="仓库" filterable >
                            <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div style="text-align:right">
                        <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                            {{ showMore ? '收起' : '展开' }}
                            <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                        </a>
                        <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-collapse-transition>
                <div v-show="showMore">
                    <el-row>
                        <el-col :span="5">
                            <div class="" @keydown.enter="btnSearch()">
                            <span class="title">盘点状态：</span>
                                <el-select size="small" style="max-width:180px;" v-model="searchForm.inventoryStatus" placeholder="盘点状态" filterable >
                                    <el-option v-for="item in inventoryStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </el-col>

                        <el-col :span="5">
                            <div class="" @keydown.enter="btnSearch()">
                            <span class="title" style="width: 96px;margin-left: -14px;">盘点负责人：</span>
                                <el-select size="small" style="max-width:180px;" v-model="searchForm.responsibleUserId" placeholder="盘点负责人" filterable >
                                    <el-option v-for="item in responsibleUserList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </el-col>

                        <el-col :span="10">
                            <div class="" @keydown.enter="btnSearch()">
                            <span class="title" style="width: 112px;margin-left: -20px;">盘点计划时间：</span>
                                <el-date-picker style="width:520px" v-model="searchForm.planBeginTime" type="daterange" range-separator="-" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                            </div>
                        </el-col>

                        
                    </el-row>
                </div>
            </el-collapse-transition>
        </el-card>
        <el-card class="table-card">
            <el-row>
                <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow(0)" v-if="permission.btn_inventory_addInventory">新增盘点任务(按库位)</el-button>
                <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow(1)" v-if="permission.btn_inventory_addInventory">新增盘点任务(按物料)</el-button>
            </el-row>
                
            <el-table  :data="tableData" stripe style="width: 100%" class="deviceTable">
                <el-table-column prop="inventoryCode" label="盘点单号" min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column prop="inventoryName" label="盘点名称" min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column prop="inventoryWay" :formatter="parseWay" label="盘点方式" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="warehouseName" label="仓库" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="areaCode" label="库区" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="planBeginTime" label="盘点计划时间" :formatter='(row, column, cellValue, index)=>$commonUtil.changeToDate(row, column, cellValue, index,true)' min-width="110"></el-table-column>
                <el-table-column prop="responsibleUserName" label="盘点负责人"  min-width="80"></el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间" show-overflow-tooltip :formatter='$commonUtil.changeToDate' min-width="110"></el-table-column>
                <el-table-column prop="inventoryStatus"  label="状态"  :formatter='parseStatus' min-width="80"></el-table-column>
                <el-table-column label="操作" fixed="right" width="160" v-if="permission.btn_inventory_list">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showViewDialog(scope.row)"  size="small">查看</el-button>
                        <el-button type="text" @click="showCheckDialog(scope.row)" v-if="scope.row.inventoryStatus==2&&permission.btn_inventory_updateInventory" size="small">审核</el-button>
                        <el-button type="text" @click="showEditDialog(scope.row)" v-if="scope.row.inventoryStatus==0&&permission.btn_inventory_updateInventory" size="small">编辑</el-button>
                        <el-button type="text" class="btn-del"  @click="deleteInventory(scope.row)" v-if="scope.row.inventoryStatus==0&&permission.btn_inventory_deleteInventory" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page" v-if="tableData.length > 0">
                <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                    <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
                </div>
            </div>
        </el-card>

        <!-- 查看盘点开始 -->
        <el-dialog title="盘点详情" @close="cancelViewDialog"  :visible.sync="viewDialogVisible" :width="W?'54%':'68%'" center :close-on-click-modal="false">
            <el-form id='pdfDom' style="width:100%;" class="add_form" :model="viewForm" :rules="rules" ref="viewForm">
                <el-row style="margin-top:20px">
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">盘点单号：</span>
                            <span class="value">{{viewForm.inventoryCode}}</span>
                        </div>
                    </el-col>
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">盘点名称：</span>
                            <span class="value">{{viewForm.inventoryName}}</span>
                        </div>
                    </el-col>
                    
                    <el-col :span='8'>
                        <div class="">
                            <span class="title" style="width: 84px;margin-left: -14px;">盘点负责人：</span>
                            <span class="value">{{viewForm.responsibleUserName}}</span>                   
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="8">
                        <div class="">
                            <span class="title">计划时间：</span> 
                            <span class="value">{{viewForm.planBeginTime}}</span> 
                        </div>
                    </el-col>
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">盘点仓库：</span>
                            <span class="value">{{viewForm.warehouseName}}</span>
                        </div>
                    </el-col>

                    <el-col :span='8'>
                        <div class="">
                            <span class="title">盘点库区：</span>
                            <span class="value">{{viewForm.areaCode}}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span='24'>
                        <div class="">
                            <span class="title">盘点备注：</span>
                            <span class="value">{{viewForm.remark}}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-table  :data="viewForm.data"  style="width: 100%;margin-bottom:10px;"  :maxHeight="410">
                    <el-table-column label="序号" type="index" min-width="60"></el-table-column>
                    <el-table-column label="物料编码" prop="materialCode"  min-width="70"></el-table-column>
                    <el-table-column label="物料名称" prop="materialName"   min-width="70"></el-table-column>
                    <el-table-column label="批次号" prop="productionBatchCode"  min-width="70"></el-table-column>
                    <el-table-column  label="单位" prop="unitOfQuantity"  min-width="70"></el-table-column>
                    <el-table-column label="库位" prop="positionName"  min-width="70"></el-table-column>
                    <el-table-column label="数量" prop="stockAmount"  min-width="50"></el-table-column>
                    <el-table-column label="实盘数量" prop="actualAmount"  min-width="60"></el-table-column>
                    <el-table-column label="盘点人" prop="executeUserName"  min-width="60"></el-table-column>
                    <el-table-column label="盘亏/盘盈" prop="inventoryLoss"  min-width="70"></el-table-column>
                </el-table> 
                <el-row style="margin-top:20px">
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">审核意见：</span>
                            <span class="value">{{viewForm.inventoryStatus|parseCheckStatus}}</span>
                        </div>
                    </el-col>
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">审核人：</span>
                            <span class="value">{{viewForm.checkUserName}}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">原因：</span>
                            <span class="value">{{viewForm.checkReason}}</span>
                        </div>
                    </el-col>
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">审核日期：</span>
                            <span class="value">{{viewForm.checkTime}}</span>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="downInfo">导 出</el-button>
                <el-button type="primary" @click="printInfo">打 印</el-button>
                <el-button   @click="cancelViewDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 查看盘点结束 -->

        <!-- 盘点审核开始 -->
        <el-dialog title="盘点审核" @close="cancelViewDialog"  :visible.sync="checkDialogVisible" :width="W?'54%':'68%'" center :close-on-click-modal="false">
            <el-form  style="width:100%;" class="add_form check_form" :model="viewForm" :rules="rules" ref="viewForm">
                <el-row style="margin-top:20px">
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">盘点单号：</span>
                            <span class="value">{{viewForm.inventoryCode}}</span>
                        </div>
                    </el-col>
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">盘点名称：</span>
                            <span class="value">{{viewForm.inventoryName}}</span>
                        </div>
                    </el-col>
                    
                    <el-col :span='8'>
                        <div class="">
                            <span class="title" style="width: 84px;margin-left: -14px;">盘点负责人：</span>
                            <span class="value">{{viewForm.responsibleUserName}}</span>                   
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="8">
                        <div class="">
                            <span class="title">计划时间：</span>
                            <span class="value">{{viewForm.planBeginTime}}</span> 
                        </div>
                    </el-col>
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">盘点仓库：</span>
                            <span class="value">{{viewForm.warehouseName}}</span>
                        </div>
                    </el-col>

                    <el-col :span='8'>
                        <div class="">
                            <span class="title">盘点库区：</span>
                            <span class="value">{{viewForm.areaCode}}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span='24'>
                        <div class="">
                            <span class="title">盘点备注：</span>
                            <span class="value">{{viewForm.remark}}</span>
                        </div>
                    </el-col>
                </el-row>
                <h4>盘点详情</h4>
                <el-table  :data="viewForm.data"  style="width: 100%;margin-bottom:10px;"  :maxHeight="400">
                    <el-table-column label="序号"  min-width="60">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit'  style="display:inline-block">
                                {{scope.$index+1}}
                            </el-form-item>
                            <span v-else >{{scope.$index+1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="物料编码" prop="materialCode"  min-width="70">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit' style="display:inline-block">
                                {{scope.row.materialCode}}
                            </el-form-item>
                            <span v-else >{{scope.row.materialCode}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="物料名称" prop="materialName"   min-width="70">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit' style="display:inline-block">
                                {{scope.row.materialName}}
                            </el-form-item>
                            <span v-else >{{scope.row.materialName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="批次号" prop="productionBatchCode"  min-width="70">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit' style="display:inline-block">
                                {{scope.row.productionBatchCode}}
                            </el-form-item>
                            <span v-else >{{scope.row.productionBatchCode}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  label="单位" prop="unitOfQuantity"  min-width="70">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit' style="display:inline-block">
                                {{scope.row.unitOfQuantity}}
                            </el-form-item>
                            <span v-else >{{scope.row.unitOfQuantity}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="库位" prop="positionName"  min-width="70">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit' style="display:inline-block">
                                {{scope.row.positionName}}
                            </el-form-item>
                            <span v-else >{{scope.row.positionName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" prop="stockAmount"  min-width="50">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit' style="display:inline-block">
                                {{scope.row.stockAmount}}
                            </el-form-item>
                            <span v-else >{{scope.row.stockAmount}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实盘数量" prop="actualAmount"  min-width="90">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit' :prop="`data[${scope.$index}].actualAmount`" :rules="rules.actualAmount" style="display:inline-block">
                                <el-input v-model="scope.row.actualAmount" placeholder="实盘数量"></el-input>
                            </el-form-item>
                            <span v-else >{{scope.row.actualAmount}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="盘点人" prop="executeUserName"  min-width="60">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit' style="display:inline-block">
                                {{scope.row.executeUserName}}
                            </el-form-item>
                            <span v-else >{{scope.row.executeUserName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="盘亏/盘盈" prop="remark"  min-width="70">
                        <template slot-scope="scope">
                            <el-form-item v-if='isEdit' style="display:inline-block">
                                {{scope.row.inventoryLoss}}
                            </el-form-item>
                            <span v-else >{{scope.row.inventoryLoss}}</span>
                        </template>
                    </el-table-column>
                </el-table> 
                <div v-if="isEdit" style="text-align:center">
                    <el-button  type="primary"  @click="editInventoryCount(2)">保存</el-button>
                    <el-button   @click="isEdit=false">取 消</el-button>
                </div>
                <el-button  v-else type="primary"  @click="editInventoryCount(1)">修改数量</el-button>
                
                <el-row style="margin-top:20px" v-if="!isEdit">
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">审核意见：</span>
                             <el-form-item  style="display:inline-block">
                                <el-radio-group v-model="viewForm.inventoryStatus">
                                    <el-radio :label="3">同意调整</el-radio>
                                    <el-radio :label="4">驳回重盘</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top:20px" v-if="!isEdit">
                    <el-col :span='8'>
                        <div class="">
                            <span class="title">原因：</span>
                            <el-form-item  style="display:inline-block">
                                <el-input v-model="viewForm.checkReason" placeholder="审核意见"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer" v-if="!isEdit">
                <el-button  type="primary"  @click="submitCheck">提 交</el-button>
                <el-button   @click="checkDialogVisible=false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 盘点审核结束 -->

        <!-- 新增库区盘点(按库区)开始 -->
        <el-dialog title="新增盘点任务(按库位)" :visible.sync="addDialogVisible" :width="span==5?'70%':'80%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" class="addForm">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class>
                            <span class="title">盘点名称：</span>
                            <el-form-item class="value" prop="inventoryName" style="display:inline-block">
                                <el-input ref="focusinput" size="small" v-model.trim="addForm.inventoryName" maxlength="16" placeholder="盘点名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                    <el-col :span="6">   
                        <div class>
                            <span class="title">仓库：</span>
                            <el-form-item class="value" prop="warehouseId" style="display:inline-block">
                                <el-select size="small" @change="warehouseSelect($event,0)" v-model="addForm.warehouseId" placeholder="选择仓库" filterable >
                                    <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class>
                            <span class="title">库区：</span>
                            <el-form-item class="value" prop="areaNameList" style="display:inline-block">
                                <el-select size="small" collapse-tags multiple @change="areaChange" v-model="addForm.areaNameList" placeholder="选择库区" filterable >
                                    <el-option v-for="item in areaList" :key="item.areaCode" :label="item.areaCode" :value="item.areaCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class>
                            <span class="title">库位：</span>
                            <el-form-item class="value" style="display:inline-block">
                                <el-select size="small" collapse-tags multiple @change="positionChange" v-model="addForm.positionIdList" placeholder="选择库位" filterable >
                                    <el-option v-for="item in positionList" :key="item.id" :label="item.positionName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class>
                            <span class="title" style="width: 84px;margin-left: -14px;">盘点负责人：</span>
                            <el-form-item class="value" prop="responsibleUserId" style="display:inline-block">
                                <el-select size="small" v-model="addForm.responsibleUserId" placeholder="选择盘点负责人" filterable >
                                    <el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <span class="title">计划时间：</span>
                        <el-form-item class="value" prop="planBeginTime" style="display:inline-block">
                            <el-date-picker :picker-options="pickerOptions" style="width:214px" v-model="addForm.planBeginTime" type="date"  value-format="yyyy-MM-dd" placeholder="计划时间" ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div>
                            <span class="title">盘点备注：</span>
                            <el-form-item class="value" style="display:inline-block">
                                <el-input size="small" v-model="addForm.remark" maxlength="16" placeholder="盘点备注"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-table  :data="positionTableData" stripe style="width: 100%" class="deviceTable">
                        <el-table-column type="index" label="序号" width="80" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="areaCode" label="库区" min-width="160" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="positionInfo" label="库位名称" min-width="260" show-overflow-tooltip></el-table-column>
                    </el-table>
                </el-row>
            </el-form>
            <div style="text-align: center" class="dialog-footer">
                <el-button type="primary" @click="addInventory(0)">确 定</el-button>
                <el-button @click="closeAddDialog">取 消</el-button>
            </div>  
        </el-dialog>
        <!--新增库区盘点(按库区)结束-->

        <!-- 新增库区盘点(按物料)开始 -->
        <el-dialog title="新增盘点任务(按物料)" :visible.sync="addDialogVisible1" :width="span==5?'60%':'70%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" class="addForm">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <div class>
                            <span class="title">盘点名称：</span>
                            <el-form-item class="value" prop="inventoryName" style="display:inline-block">
                                <el-input ref="focusinput" size="small" v-model.trim="addForm.inventoryName" maxlength="16" placeholder="盘点名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                    <el-col :span="8">   
                        <div class>
                            <span class="title">仓库：</span>
                            <el-form-item class="value" prop="warehouseId" style="display:inline-block">
                                <el-select size="small" @change="warehouseSelect($event,1)" v-model="addForm.warehouseId" placeholder="选择仓库" filterable >
                                    <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                    <el-col :span="8">
                        <div class>
                            <span class="title" style="width: 84px;margin-left: -14px;">盘点负责人：</span>
                            <el-form-item class="value" prop="responsibleUserId" style="display:inline-block">
                                <el-select size="small" v-model="addForm.responsibleUserId" placeholder="选择盘点负责人" filterable >
                                    <el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                </el-row>
                <el-row :gutter="20">
                    
                    <el-col :span="8">
                        <span class="title">计划时间：</span>
                        <el-form-item class="value" prop="planBeginTime" style="display:inline-block">
                            <el-date-picker :picker-options="pickerOptions" style="width:214px" v-model="addForm.planBeginTime" type="date"  value-format="yyyy-MM-dd" placeholder="计划时间" ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div>
                            <span class="title">盘点备注：</span>
                            <el-form-item class="value" style="display:inline-block">
                                <el-input size="small" v-model="addForm.remark" maxlength="16" placeholder="盘点备注"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin:10px 0">
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="addMaterial">新增物料</el-button> 
                </el-row>

                <el-table class="stock-material" :data='addForm.data' border maxHeight="500">
                    <el-table-column label="物料编码" min-width="110" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="`data[${scope.$index}].materialId`" :rules="rules.materialId" style="display:inline-block">
                                <el-select  filterable clearable   v-model="scope.row.materialId"  placeholder="物料编码" style="display:block">
                                    <el-option v-for="item in materialList" :key="item.materialId" :label="item.materialCode" :value="item.materialId"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="物料名称" min-width="110" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="`data[${scope.$index}].materialId`" :rules="rules.materialId" style="display:inline-block">
                                <el-select  filterable clearable   v-model="scope.row.materialId"  placeholder="物料名称" style="display:block">
                                    <el-option v-for="item in materialList" :key="item.materialId" :label="item.materialName" :value="item.materialId"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column label="规格" min-width="110" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="`data[${scope.$index}].materialId`" :rules="rules.materialId" style="display:inline-block">
                                <el-select filterable clearable  v-model="scope.row.materialId"  placeholder="规格" style="display:block">
                                    <el-option v-for="item in materialList" :key="item.materialId" :label="item.specification" :value="item.materialId"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="50">
                        <template slot-scope="scope">
                            <div class="delete" type="primary" @click="deleteMaterial(scope.$index)"></div>
                        </template>
                    </el-table-column>
                </el-table>
                
            </el-form>
            <div style="text-align: center;margin-top:20px" class="dialog-footer">
                <el-button type="primary" @click="addInventory(1)">确 定</el-button>
                <el-button @click="closeAddDialog">取 消</el-button>
            </div>  
        </el-dialog>
        <!--新增库区盘点(按物料)结束-->

        <!-- 编辑库区盘点(按库区)开始 -->
        <el-dialog title="编辑盘点任务(按库位)" :visible.sync="editDialogVisible" :width="span==5?'70%':'80%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" class="addForm">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class>
                            <span class="title">盘点名称：</span>
                            <el-form-item class="value" prop="inventoryName" style="display:inline-block">
                                <el-input ref="focusinput" size="small" v-model.trim="addForm.inventoryName" maxlength="16" placeholder="盘点名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                    <el-col :span="6">   
                        <div class>
                            <span class="title">仓库：</span>
                            <el-form-item class="value" prop="warehouseId" style="display:inline-block">
                                <el-select size="small" @change="warehouseSelect($event,0)" v-model="addForm.warehouseId" placeholder="选择仓库" filterable >
                                    <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>

                    <el-col :span="6">
                        <div class>
                            <span class="title">库区：</span>
                            <el-form-item class="value" prop="areaNameList" style="display:inline-block">
                                <el-select size="small" collapse-tags multiple @change="areaChange" v-model="addForm.areaNameList" placeholder="选择库区" filterable >
                                    <el-option v-for="item in areaList" :key="item.areaCode" :label="item.areaCode" :value="item.areaCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>

                    <el-col :span="6">
                        <div class>
                            <span class="title">库位：</span>
                            <el-form-item class="value" style="display:inline-block">
                                <el-select size="small" collapse-tags multiple @change="positionChange" v-model="addForm.positionIdList" placeholder="选择库位" filterable >
                                    <el-option v-for="item in positionList" :key="item.id" :label="item.positionName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class>
                            <span class="title" style="width: 84px;margin-left: -14px;">盘点负责人：</span>
                            <el-form-item class="value" prop="responsibleUserId" style="display:inline-block">
                                <el-select size="small" v-model="addForm.responsibleUserId" placeholder="选择盘点负责人" filterable >
                                    <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <span class="title">计划时间：</span>
                        <el-form-item class="value" prop="planBeginTime" style="display:inline-block">
                            <el-date-picker :picker-options="pickerOptions" style="width:214px" v-model="addForm.planBeginTime" type="date"  value-format="yyyy-MM-dd" placeholder="计划时间" ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div>
                            <span class="title">盘点备注：</span>
                            <el-form-item class="value" style="display:inline-block">
                                <el-input size="small" v-model="addForm.remark" maxlength="16" placeholder="盘点备注"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-table  :data="positionTableData" stripe style="width: 100%" class="deviceTable">
                        <el-table-column type="index" label="序号" width="80" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="areaCode" label="库区" min-width="160" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="positionInfo" label="库位名称" min-width="260" show-overflow-tooltip></el-table-column>
                    </el-table>
                </el-row>
                
            </el-form>
            <div style="text-align: center" class="dialog-footer">
                <el-button type="primary" @click="submitEdit(0)">确 定</el-button>
                <el-button @click="closeEditDialog">取 消</el-button>
            </div>  
        </el-dialog>
        <!--编辑库区盘点(按库区)结束-->

         <!-- 编辑库区盘点(按物料)开始 -->
        <el-dialog title="编辑盘点任务(按物料)" :visible.sync="editDialogVisible1" :width="span==5?'60%':'70%'" center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="addForm" class="addForm">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <div class>
                            <span class="title">盘点名称：</span>
                            <el-form-item class="value" prop="inventoryName" style="display:inline-block">
                                <el-input ref="focusinput" size="small" v-model.trim="addForm.inventoryName" maxlength="16" placeholder="盘点名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                    <el-col :span="8">   
                        <div class>
                            <span class="title">仓库：</span>
                            <el-form-item class="value" prop="warehouseId" style="display:inline-block">
                                <el-select size="small" @change="warehouseSelect($event,1)" v-model="addForm.warehouseId" placeholder="选择仓库" filterable >
                                    <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                    <el-col :span="8">
                        <div class>
                            <span class="title" style="width: 84px;margin-left: -14px;">盘点负责人：</span>
                            <el-form-item class="value" prop="responsibleUserId" style="display:inline-block">
                                <el-select size="small" v-model="addForm.responsibleUserId" placeholder="选择盘点负责人" filterable >
                                    <el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    
                </el-row>
                <el-row :gutter="20">
                    
                    <el-col :span="8">
                        <span class="title">计划时间：</span>
                        <el-form-item class="value" prop="planBeginTime" style="display:inline-block">
                            <el-date-picker :picker-options="pickerOptions" style="width:214px" v-model="addForm.planBeginTime" type="date"  value-format="yyyy-MM-dd" placeholder="计划时间" ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div>
                            <span class="title">盘点备注：</span>
                            <el-form-item class="value" style="display:inline-block">
                                <el-input size="small" v-model="addForm.remark" maxlength="16" placeholder="盘点备注"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin:20px 0">
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="addMaterial">新增物料</el-button> 
                </el-row>

                <el-table class="stock-material" :data='addForm.data' border maxHeight="500">
                    <el-table-column label="物料编码" min-width="110" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="`data[${scope.$index}].materialId`" :rules="rules.materialId" style="display:inline-block">
                                <el-select  filterable clearable   v-model="scope.row.materialId"  placeholder="物料编码" style="display:block">
                                    <el-option v-for="item in materialList" :key="item.materialId" :label="item.materialCode" :value="item.materialId"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="物料名称" min-width="110" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="`data[${scope.$index}].materialId`" :rules="rules.materialId" style="display:inline-block">
                                <el-select  filterable clearable   v-model="scope.row.materialId"  placeholder="物料名称" style="display:block">
                                    <el-option v-for="item in materialList" :key="item.materialId" :label="item.materialName" :value="item.materialId"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column label="规格" min-width="110" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-form-item :prop="`data[${scope.$index}].materialId`" :rules="rules.materialId" style="display:inline-block">
                                <el-select filterable clearable  v-model="scope.row.materialId"  placeholder="规格" style="display:block">
                                    <el-option v-for="item in materialList" :key="item.materialId" :label="item.specification" :value="item.materialId"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="50">
                        <template slot-scope="scope">
                            <div class="delete" type="primary" @click="deleteMaterial(scope.$index)"></div>
                        </template>
                    </el-table-column>
                </el-table>
                
            </el-form>
            <div style="text-align: center;margin-top:20px" class="dialog-footer">
                <el-button type="primary" @click="submitEdit(1)">确 定</el-button>
                <el-button @click="closeEditDialog">取 消</el-button>
            </div>  
        </el-dialog>
        <!--编辑库区盘点(按物料)结束-->


    </div>
</template>

<script>
import outputPdf from '@/util/outputPdf'
export default {
    name: 'InventoryTask',
	data () {
        return {
            showMore:false,
            pickerOptions:{
                disabledDate(time) {
                    return time.getTime() < Date.now()-60*60*24*1000;
                },
            },
            loading:false,
            isEdit:false,
            responsibleUserList:[],
            inventoryCodeList:[],
            materialList:[],
            addDialogVisible:false,
            addDialogVisible1:false,
            fristLoad:false,
            userList:[],
            isConfirm:null,
            selectId:null,
            selectData:[],
            detailList:[],
            viewDialogVisible:false,
            W:false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm:{
                inventoryId:null,
                inventoryName:'',
                inventoryWay:null,
                warehouseId:null,
                inventoryStatus:null,
                responsibleUserId:null,
                planBeginTime:[]
            },
            areaList:[],
            positionList:[],
            positionTableData:[],
            addForm:{
                inventoryName:'',
                warehouseId:null,
                areaNameList:[],
                positionIdList:[],
                responsibleUserId:null,
                planBeginTime:null,
                data:[],
                remark:''
            },
            viewForm:{
                data:[{}],
                inventoryName:'',
                inventoryCode:'',
                responsibleUserName:'',
                warehouseName:'',
                areaCode:'',
                remark:'',
                planBeginTime:'',
            },
            rules:{
                inventoryName:[
                    { required: true, message: '请输入盘点名称', trigger: 'blur' }
                ],
                warehouseId:[
                    { required: true, message: '请选择仓库', trigger: 'blur' }
                ],
                areaNameList:[
                    { required: true, message: '请选择库区', trigger: 'blur' }
                ],
                responsibleUserId:[
                    { required: true, message: '请选择盘点负责人', trigger: 'blur' }
                ],
                planBeginTime:[
                    { required: true, message: '请选择盘点负责人', trigger: 'blur' }
                ],
                materialId:[
                    { required: true, message: '请选择物料', trigger: 'blur' }
                ],
                actualAmount:[
                    { required: true, message: '请输入实盘数量', trigger: 'blur' },
                    {validator(rule, value, callback) {
                            if ( value === '' ||value==null||value==undefined) {
                                callback(new Error('实盘数量不能为空'))
                            } else {
                                value = Number(value)
                                
                                if(isNaN(value)){
                                    callback(new Error('实盘数量必须为数字'))
                                }else{
                                    if(value<0){
                                        callback(new Error('实盘数量不能小于零'))
                                    }else{
                                        callback()
                                    }
                                }
                            }
                        },trigger: 'blur'}
                ]
            },
            inventoryStatusOptions:[ //0-待盘点 1-执行中 2-待审核 3-审核通过 4-重新盘点
                {id:0,value:0,label:'待盘点'},
                {id:1,value:1,label:'执行中'},
                {id:2,value:2,label:'待审核'},
                {id:3,value:3,label:'审核通过'},
                {id:4,value:4,label:'审核不通过'},
            ], 
            tableData:[],
            tableCurrentPage:1,
            tableTotalPage:2,
            viewDialogVisible:false,
            editDialogVisible:false,
            editDialogVisible1:false,
            checkDialogVisible:false,
            data: {
				token: localStorage.getItem("token"),
            },
            warehouseList:[],
            permission:JSON.parse(localStorage.getItem("permission")),
            orderType:'DESC',
            orderColumn:'gmtCreate',//排序列
            defaultSort: {prop: 'gmtCreate', order: 'descending'},//默认排序设置
        }
    },
    mounted:function(){
        this.initTable();
        this.loadResponsibleUserList()
        this.loadUserList()
        this.loadWarehouseList()
        this.loadInventoryCodeList()
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
         w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
    },
    computed:{
        span(){
           return this.W?5:5
        }
    },
    deactivated:function(){
        console.log("deactivated");
    },
    methods:{
        toggleShowMore(){
            this.showMore = ! this.showMore
        },
        downInfo(){
            let element = document.querySelector('#pdfDom')
             outputPdf({
                    element,
                    filename:'盘点记录.pdf'
                }).then(()=>{
                    log('导入成功')
                })
        },

        printInfo(){
            localStorage.setItem('printStockType',5)
            localStorage.setItem('printStockInfo',JSON.stringify(this.viewForm))
            let routeUrl = this.$router.resolve({path: "/Print/PrintStock"});
            window.open(routeUrl.href, '_blank');
        },

        editInventoryCount(type){
            if(type==1){
                this.isEdit = true
            }else{
                this.$refs['viewForm'].validate((valid) => {
                    if (valid) {
                        this.$RequestUtil.post({
                            url: '/api/inventory/updateActualAmount',
                            type:'sync',
                            params: {
                                inventoryDetailVoList:this.viewForm.data.map(item=>{
                                    return {
                                        inventoryDetailId:item.inventoryDetailId,
                                        actualAmount:item.actualAmount
                                    }
                                })
                            },
                            success: (res) => {
                                if(res.code == 0){
                                    this.$message({
                                        type:'success',
                                        message:'修改盘点数量成功'
                                    })
                                    this.isEdit = false
                                    
                                }else{
                                    this.$message({
                                        type:'error',
                                        message:res.msg||res.message
                                    })
                                }
                            }
                        });
                    }
                })

                this.isEdit = false
            }
        },

        submitCheck(){
            if(this.viewForm.inventoryStatus!=3&&this.viewForm.inventoryStatus!=4){
                this.$message.error('请选择审核结果')
                return
            }
            this.$refs['viewForm'].validate((valid) => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: '/api/inventory/submitAudit',
                        type:'sync',
                        params: {
                            inventoryStatus:this.viewForm.inventoryStatus,
                            inventoryId:this.viewForm.id,
                            checkReason:this.viewForm.checkReason,
                        },
                        success: (res) => {
                            if(res.code == 0){
                                this.$message({
                                    type:'success',
                                    message:'审核成功'
                                })
                                this.checkDialogVisible = false
                                this.initTable()
                                
                            }else{
                                this.$message({
                                    type:'error',
                                    message:res.msg||res.message
                                })
                            }
                        }
                    });
                }
            })
        },

        loadUserList(){
			this.$RequestUtil.get({
				url: '/api/select/listWorker',
				params: {},
				success: (res) => {
					if(res.code == 0){
						this.userList = res.data;
					}
				}
			});
        },

        areaChange(ev){
            let arr = []
            let positionTableData = []
            this.areaList.forEach(item=>{
                if(ev.includes(item.areaCode)){
                    arr = arr.concat(item.positionList)
                    positionTableData.push({
                        areaCode:item.areaCode,
                        positionInfo:'',
                        positionList:[],
                    })
                }
            })
            this.positionTableData = positionTableData
            this.positionList = arr
           
            if(this.addForm.positionIdList.length>0){
                let positionIdList = commonUtils.cloneObj(this.addForm.positionIdList)
                this.addForm.positionIdList = positionIdList.filter(item=>arr.map(a=>a.id).includes(item))
                this.positionChange(this.addForm.positionIdList)
            }
        },
        
        positionChange(ev){
            let positionTableData = this.positionTableData.map(item=>{
                return {areaCode:item.areaCode,positionInfo:'',positionList:[]}
            })
            this.areaList.forEach(item=>{
                item.positionList.forEach(p=>{
                    if(ev.includes(p.id)){
                        positionTableData.forEach(f=>{
                            if(f.areaCode==item.areaCode){
                                f.positionInfo = f.positionInfo?f.positionInfo+', '+p.positionName:p.positionName
                                f.positionList.push(p)
                            }
                        })
                        
                    }
                })
                
            })
            this.positionTableData = positionTableData
        },

        async warehouseSelect(ev,type){
            if(type==0){
                this.areaList = await this.loadAreaListByWarehouseId(ev)
                this.addForm.areaNameList = []
                this.addForm.positionIdList = []
                this.positionTableData = []
            }else{
                this.materialList = await this.loadMaterialListByWarehouseId(ev)
            }
            
        },
    
        async loadAreaListByWarehouseId(warehouseId){
            let {data,msg,message,code} = await this.$RequestUtil.getAsync({url: '/api/factoryModel/getAreaPositionList',params: {warehouseId}})
            if(code==0){
                return data 
            }else{
                this.$message.error(msg||message)
            }
        },

        async loadMaterialListByWarehouseId(warehouseId){
            let {data,msg,message,code} = await this.$RequestUtil.getAsync({url: '/api/inventory/getMaterialInfoList',params: {warehouseId}})
            if(code==0){
                return data 
            }else{
                this.$message.error(msg||message)
            }
        },

        addWindowShow(type){
            if(type==1){
                this.addDialogVisible1 = true
            }else{
                this.addDialogVisible = true
                this.positionTableData = []
            }
        },

        closeAddDialog(){
            this.addForm={
                inventoryName:'',
                warehouseId:null,
                areaNameList:[],
                positionIdList:[],
                responsibleUserId:null,
                planBeginTime:null,
                data:[],
                remark:''
            }
            this.addDialogVisible = false;
            this.addDialogVisible1 = false;
        },

        closeEditDialog(){
            this.addForm={
                inventoryName:'',
                warehouseId:null,
                areaNameList:[],
                positionIdList:[],
                responsibleUserId:null,
                planBeginTime:null,
                data:[],
                remark:''
            }
            this.editDialogVisible = false;
            this.editDialogVisible1 = false;
        },

        async loadInventoryDetail(inventoryId,inventoryStatus){
            let {data,msg,message,code} = await this.$RequestUtil.getAsync({url: '/api/inventory/getInventoryDetails',params: {inventoryId,inventoryStatus}})
            if(code==0){
                return data 
            }else{
                this.$message.error(msg||message)
            }
        },

        async showEditDialog(rowData){
            let {data} = await this.$RequestUtil.getAsync({url: '/api/inventory/getDetails',params: {id:rowData.id}})
            data.planBeginTime = commonUtils.timestampToDate(data.planBeginTime,true)
            this.addForm = data
            await this.warehouseSelect(this.addForm.warehouseId,rowData.inventoryWay)
            if(rowData.inventoryWay==0){
                this.addForm.areaNameList = data.areaPositionList.map(item=>item.areaCode)
                let positionIdList = []
                data.areaPositionList.forEach(item=>{
                    item.positionList.forEach(p=>{
                        positionIdList.push(p.id)
                    })
                })
               
                this.addForm.positionIdList = positionIdList
                 this.areaChange(this.addForm.areaNameList)
                this.editDialogVisible = true

            }else{
                this.editDialogVisible1 = true
                this.addForm.data = data.materialIdList.map(item=>{
                    return {materialId:item}
                })
            }
        },

        submitEdit(type){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.addForm.updateType = type
                    if(type==0){
                            this.addForm.areaPositionList = this.positionTableData.map(item=>{
                                return {
                                    areaCode:item.areaCode,
                                    positionList:item.positionList.map(p=>p.id)
                                }
                            })
                            if(this.addForm.areaPositionList.length==0){
                                this.$message.error('库区不能为空')
                                return
                            }
                    }else{
                        this.addForm.materialIdList = this.addForm.data.map(item=>item.materialId)
                        if(this.addForm.materialIdList.length==0){
                            this.$message.warning('物料不能为空请选择物料')
                            return
                        }
                    }
                   
                    this.$RequestUtil.post({
                        url: '/api/inventory/updateInventory',
                        type:'sync',
                        params: this.addForm,
                        success: (res) => {
                            if(res.code == 0){
                                this.$message({
                                    type:'success',
                                    message:'修改成功'
                                })
                                this.initTable();
                                this.closeEditDialog()
                            }else{
                                this.$message({
                                    type:'error',
                                    message:res.msg||res.message
                                })
                            }
                        }
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: '请补充必填项!'
                    });
                }
            });
        },

        async showCheckDialog(rowData){
            
            this.viewForm = commonUtils.cloneObj(rowData)
            this.isEdit = false
            this.viewForm.planBeginTime = commonUtils.timestampToDate(rowData.planBeginTime,true)
           
            let {planBeginTime,remark,checkReason,checkTime,checkUserName,inventoryDetailVoList} = await this.loadInventoryDetail(rowData.id,rowData.inventoryStatus)
            // this.viewForm.planBeginTime = planBeginTime
            this.viewForm.remark = remark
            // this.viewForm.checkReason = checkReason
            this.$set(this.viewForm,'checkReason',checkReason)
            this.viewForm.checkUserName = checkUserName
            this.viewForm.data = inventoryDetailVoList
            this.checkDialogVisible = true
           
            
        },

        addInventory(type){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.addForm.addType = type
                    if(type==0){
                            this.addForm.areaPositionList = this.positionTableData.map(item=>{
                                return {
                                    areaCode:item.areaCode,
                                    positionList:item.positionList.map(p=>p.id)
                                }
                            })
                    }else{
                        this.addForm.materialIdList = this.addForm.data.map(item=>item.materialId)
                        if(this.addForm.materialIdList.length==0){
                            this.$message.warning('物料不能为空请选择物料')
                            return
                        }
                    }
                   
                    this.$RequestUtil.post({
                        url: '/api/inventory/addInventory',
                        type:'sync',
                        params: this.addForm,
                        success: (res) => {
                            if(res.code == 0){
                                this.$message({
                                    type:'success',
                                    message:'添加成功'
                                })
                                this.initTable();
                                this.closeAddDialog()
                            }else{
                                this.$message({
                                    type:'error',
                                    message:res.msg||res.message
                                })
                            }
                        }
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: '请补充必填项!'
                    });
                }
            });
        },

        deleteMaterial(index) {
            this.addForm.data.splice(index, 1);
        },

        addMaterial() {
            this.addForm.data.push({materialId:null})
        },

        parseStyle(rowData){
            if(rowData.isConfirm != null){
                let str = ''
                if(rowData.isConfirm){
                    str = 'green'
                }else{
                    str = 'red'
                }
                return str
            }
        },

        sortChangeEvent(param){
            let orderType = param.order;
            let orderColumn = param.prop;
            this.orderColumn = orderColumn;
            if(orderType == 'descending'){
                this.orderType = 'DESC';
            }else if(orderType == 'ascending'){
                this.orderType = 'ASC';
            }else{
                this.orderType = orderType;
                this.orderColumn = null
            }
            this.search(1);
            this.tableCurrentPage = 1
        },

        async loadWarehouseList(id){
			let res = await this.$RequestUtil.getAsync({url: '/api/select/listDefaultMaterialFactoryModel',params: {id}})
			this.warehouseList = res.data
        },
        
        loadResponsibleUserList(){
            this.$RequestUtil.get({
				url: '/api/inventory/getResponsibleUserList',
                params: {
                   
                },
                type:'sync',
				success: (res) => {
					if(res.code == 0){
                        this.responsibleUserList = res.data;
					}
				}
			});
        },

        async loadInventoryCodeList(code){
            let {data} = await this.$RequestUtil.getAsync({url: '/api/inventory/getInventoryCodeList',params: {code}})
            this.inventoryCodeList = data
        },

        async loadCodeList(query){
            this.loading = true
            await this.loadInventoryCodeList(query)
            log(this.inventoryCodeList,444)
            this.loading = false
        },

        selecChange(ev){
            this.selectData = ev
        },

        cancelViewDialog(){
            this.viewDialogVisible = false
            this.detailList = []
            this.selectData = []
            this.selectId=null
            this.isConfirm=null
        },

        sumitGap(){
            let gapList = []
            this.selectData.forEach(item=>{
                gapList.push(item.id)
            })
            this.$RequestUtil.post({
                url: '/api/recordOfStockCounting/confirmGap',
                type:'sync',
                params: {
                    gapList,
                    recordOfStockCountingId:this.selectId
                },
                success:res=>{
                    if(res.code==0){
                        this.$message.success('操作成功')
                        this.cancelViewDialog()
                        this.initTable();
                    }else{
                        this.$message.error(res.msg||res.message);

                    }
                }
            })
        },

        confirmGap(){
            if(this.selectData.length==0){
                this.$confirm(' 您尚未勾选任何记录，是否确认操作?', '提示', {
                    cancelButtonClass: "btn-custom-cancel",
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.sumitGap()
                })
            }else{
                this.sumitGap()
            }
        },

        btnSearch:function(){
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },

        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.inventoryId = null
            form.inventoryName = ''
            form.inventoryWay = null
            form.warehouseId = null
            form.inventoryStatus = null
            form.responsibleUserId = null
            form.planBeginTime = []
        },

        search:function(){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                    inventoryId:null,
                    inventoryName:'',
                    inventoryWay:null,
                    warehouseId:null,
                    inventoryStatus:null,
                    responsibleUserId:null,
                    planBeginTime:[]
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            let planBeginTimeStart,planBeginTimeEnd
            if(temp.planBeginTime&&temp.planBeginTime.length==2){
                planBeginTimeStart = temp.planBeginTime[0]
                planBeginTimeEnd = temp.planBeginTime[1]
            }
            this.$RequestUtil.post({
                url: '/api/inventory/list',
                type:'sync',
				params: {
                    pageNum:this.tableCurrentPage,
                    pageSize:10,
                    planBeginTimeStart,
                    planBeginTimeEnd,
                    inventoryId:temp.inventoryId,
                    inventoryName:temp.inventoryName,
                    inventoryWay:temp.inventoryWay,
                    warehouseId:temp.warehouseId,
                    inventoryStatus:temp.inventoryStatus,
                    responsibleUserId:temp.responsibleUserId,
                },
                success: (res) => {
                    if(res.code==0){
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if(res.totalPages == 0&&this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            });
        },

        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },

        initTable:function(){
            this.search();
        },

        async showViewDialog(rowData){
            this.viewForm = commonUtils.cloneObj(rowData)
            this.viewForm.planBeginTime = commonUtils.timestampToDate(rowData.planBeginTime,true)
            // if(rowData.inventoryStatus>0){
                let {planBeginTime,remark,checkReason,checkTime,checkUserName,inventoryDetailVoList} = await this.loadInventoryDetail(rowData.id,rowData.inventoryStatus)
                // this.viewForm.planBeginTime = planBeginTime
                this.viewForm.remark = remark
                this.viewForm.checkReason = checkReason
                this.viewForm.checkUserName = checkUserName
                
                this.viewForm.checkTime = commonUtils.timestampToDate(checkTime)
                this.viewForm.data = inventoryDetailVoList
            // }
            this.viewDialogVisible = true
            
        },

        async loadRecordsDetail(id){
            let res = await this.$RequestUtil.postAsync({ url: '/api/inventoryOfStockCounting/listGapDetail',type:'sync',params: {recordOfStockCountingId:id}})
            return res.data
        },

        parseDate:function(rowData){
            if(rowData.gmtCreate != null){
                let dateString = commonUtils.timestampToDate(rowData.gmtCreate);
                return dateString;
            }
        },

        parseModified(rowData){
            if(rowData.submitTime != null){
                let dateString = commonUtils.timestampToDate(rowData.submitTime);
                return dateString;
            }
        },

        parseStatus(rowData){
            return (this.inventoryStatusOptions.find(item=>item.value==rowData.inventoryStatus)||{}).label
        },

        parseWay(rowData){
            if(rowData.inventoryWay==0){
                return '按库位'
            }else{
                return '按物料'
            }
        },

        deleteInventory(rowData){
            this.$confirm('此操作将删除该盘点任务, 删除后不可撤销，是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.get({
                    url: '/api/inventory/deleteInventory',
                    type: 'sync',
                    params: {
                        id: rowData.id
                    },
                    success: (res) => {
                        if (res.code != -1) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search(1);
                        } else {
                            this.$message.error(res.message || res.msg)
                        }
                    }
                })
            })
        },
    },
    filters:{
        parseCheckStatus(status){
            if(status==3){
                return '同意调整'
            }else if(status==4){
                return '驳回重盘'
            }else{
                return ''
            }
        }
    }
}
</script>

<style scoped>

.table_searchbar .title11{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.add_form .title{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display:inline-block;
    text-align: right;
    width: 70px;
}
.add_form .value{
    display:inline-block
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.import_upload{
	display: inline;
}
.page{
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1450px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
.delete {
    width: 18px;
    height: 19px;
    background-image: url("../../../static/img/del.png");
    cursor: pointer;
    background-repeat: no-repeat;
    margin-left: 4px;
}
.delete:hover {
    background-image: url("../../../static/img/del-hover.png");
    background-repeat: no-repeat;
}
</style>
<style>
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
/* #InventoryTask .el-table th>.cell{
  padding-left: 14px!important;
} */
@media screen and (max-width: 1366px){
    #InventoryTask .el-date-editor.el-input, #InventoryTask .el-date-editor.el-input__inner {
        width: 130px !important;
    }
    #InventoryTask .check_form .el-input {
        width: auto;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/stock/InventoryTask.vue